<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeBookingStatus
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=2973-37221
 */
import type { BadgeBookingStatusProps } from '../types/interfaces'

import { useBadgeBookingStatus } from '../composables/use-badge-booking-status.hook'
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgeBookingStatus',
})

const props = defineProps<BadgeBookingStatusProps>()

const {
  color,
  text,
  icon,
} = useBadgeBookingStatus({ props })
</script>

<template>
  <AppBadge
    :color="color"
    :text="text"
    :prepend-icon="icon"
  />
</template>
